import React from 'react'

function Adv() {
  return (
    <div>
        <section className='container px-2 px-sm-3 my-4'>
          <div
            className="bg-holder rounded-4"
            style={{
              backgroundImage: "url(/img/gallery/cta-one-bg.png)",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          ></div>

          <div className="container position-relative">
            <div className="row justify-content-center mb-4">
              <div className="col-xxl-10">
                <div
                  className="card card-span shadow-warning"
                  style={{ borderRadius: 24 }}
                >
                  <div className="card-body py-4 px-3">
                    {/* Replaced fixed side-by-side rows with auto-adjusting flex grids */}
                    <div className="row g-3 justify-content-center text-center text-md-start">
                      <div className="col-sm-6 col-md-4">
                        <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-3">
                          <img
                            src="/img/icons/discounts.png"
                            style={{ width: "70px", height: "auto" }}
                            alt="Discounts"
                          />
                          <div>
                            <h4 className="fw-bolder text-1000 mb-0 text-gradient">
                              Daily Discounts
                            </h4>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-sm-6 col-md-4 border-start-md">
                        <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-3">
                          <img
                            src="/img/icons/live-tracking.png"
                            style={{ width: "70px", height: "auto" }}
                            alt="Tracking"
                          />
                          <div>
                            <h4 className="fw-bolder text-1000 mb-0 text-gradient">
                              Live Tracking
                            </h4>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-sm-6 col-md-4 border-start-md">
                        <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-3">
                          <img
                            src="/img/icons/quick-delivery.png"
                            style={{ width: "70px", height: "auto" }}
                            alt="Delivery"
                          />
                          <div>
                            <h4 className="fw-bolder text-1000 mb-0 text-gradient">
                              Quick Delivery
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile style overrides selector safety layout rules */}
            <style>{`
              @media (min-width: 768px) {
                .border-start-md { border-left: 1px solid #dee2e6 !important; }
              }
            `}</style>

            <div className="row flex-center align-items-center mt-4 g-4">
              <div className="col-md-5 d-none d-md-block text-center">
                <img
                  className="img-fluid"
                  src="/img/gallery/phone-cta-one.png"
                  alt="App Snapshot"
                  style={{ maxHeight: "400px", objectFit: "contain" }}
                />
              </div>
              <div className="col-md-7 col-lg-5 text-center text-md-start">
                <h1 className="text-primary fw-bold" style={{ fontSize: "clamp(1.8rem, 4vw, 2.5rem)" }}>Install the app</h1>
                <p className="my-3">
                   Deliciousness, Ready When You Are{" "}
                  <br className="d-none d-xl-block" />
                  From everyday favorites to irresistible frozen treats, discover quality frozen foods at great prices. Shop now and bring convenience to your kitchen.
                </p>
                <div className="d-flex flex-wrap justify-content-center justify-content-md-start gap-2 mt-3">
                  <a
                    href="https://www.apple.com/app-store/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="/img/gallery/app-store.svg" style={{ width: "140px" }} alt="App Store" />
                  </a>
                  <a href="https://play.google.com/store/apps" target="_blank" rel="noreferrer">
                    <img src="/img/gallery/google-play.svg" style={{ width: "140px" }} alt="Google Play" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
    </div>
  )
}

export default Adv